import React from 'react';
import clsx from 'clsx';
import { Input as CustomInput } from 'antd';
import styles from '../Components.module.less';

interface InputProps {
  label: string;
  placeholder: string;
  value: string;
  error?: boolean;
  onChange: (value: string) => void;
}

export const Input: React.FC<InputProps> = ({ label, placeholder, value, error, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={styles.root}>
      {label && <h6>{label}</h6>}
      <CustomInput
        className={clsx(styles.field, error && styles.error)}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};
